/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React from 'react';import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import Loading from '../../../components/loading/Loading';

export default function Remove({
  openDelete,
  setOpenDelete,
  loadingDelete,
  handleDelete,
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      onClose={() => setOpenDelete(false)}
      open={openDelete}
      fullWidth
      maxWidth="sm"
    >
      <Loading
        open={loadingDelete}
        msg={t('billsToPay.deleteDialog.loading')}
      />
      <DialogTitle id="simple-dialog-title">
        {t('billsToPay.deleteDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={4}
          style={{
            justifyContent: 'center',
          }}
        >
          <Grid item xs={12} sm={8}>
            <p
              style={{
                fontSize: '20px',
                textAlign: 'justify',
              }}
            >
              {`${t('billsToPay.deleteDialog.message')}`}
            </p>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ height: 40 }}
          onClick={() => setOpenDelete(false)}
          variant="text"
          color="primary"
        >
          {t('billsToPay.createDialog.buttons.cancel')}
        </Button>
        <Button
          style={{ height: 40, backgroundColor: 'red', color: 'white' }}
          onClick={handleDelete}
          variant="contained"
          disabled={loadingDelete}
        >
          {t('billsToPay.deleteDialog.buttons.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
